import { ErrorPageBase } from '@/pages/ErrorPage';

export default function ConnectionErrorPage() {
  return (
    <ErrorPageBase
      code="📡"
      title="Connection Error"
      description="Unable to connect to the server. This could be due to network issues, CORS configuration, or server unavailability. Please check your connection and try again."
      action={{
        label: 'Retry',
        onClick: () => window.location.reload(),
      }}
    />
  );
}
